export const environment = {
  production: true,
  auth_token_key: 'SMART_VETTY_AUTH_TOKEN',
  api_url: 'https://api.smartvetty.com/bg/api/',
  asset_url: 'https://api.smartvetty.com/',
 
};
